import { CustomState } from "@bevco/Store/Reducers";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { UpdateCartLineApiParameter } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateCartLineParameter {
    onSuccess?: () => void;
    cartLineERP: string;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const DispatchCompleteUpdateCartLine: HandlerType = props => {
    const state = props.getState() as CustomState;
    const validCart = state.checkoutShipping.cartLines.filter(
        (cartLine: any) => cartLine.material.trim() !== props.parameter.cartLineERP.trim(),
    );

    props.dispatch({
        type: "Custom/CheckoutShipping/CartLines",
        cartLines: validCart,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [DispatchCompleteUpdateCartLine, ExecuteOnSuccessCallback];

const updateValidCartLine = createHandlerChainRunner(chain, "UpdateCartLine");
export default updateValidCartLine;
